<template>
  <div class="content">
    <div class="searchModel">
      <el-button type="primary" @click.prevent="sendApplication" size="mini">免训申请</el-button>
    </div>
    <div class="table1" v-if="list.length!==0" style="width:100%">
      <el-table
        :data="list"
        style="width:100%"
        border
        height="490px"
      >
        <el-table-column width="140px" label="晋升级别" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.typename }}</span>
          </template>
        </el-table-column>

        <el-table-column width="140px" :label="'申请时间'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="200px" show-overflow-tooltip :label="'申请理由'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.cause }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="'附件'" align="center" width="80" prop="fileurl">
          <template slot-scope="scope">
            <el-button v-if="scope.row.files" type="text" @click="openfileList(scope.row)">查看</el-button>
            <span v-else>无</span>
          </template>
        </el-table-column>

        <el-table-column width="85px" :label="'审核状态'" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">待审核</span>
            <span v-else-if="scope.row.status == 1">审核通过</span>
            <span v-else>不通过</span>
          </template>
        </el-table-column>

        <el-table-column align="center" width="150" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="openAuditList(scope.row)" size="mini">审核记录</el-button>
            <el-button @click.prevent="openSeeApplication(scope.row)" type="text" size="mini">查看申请表</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else style="margin-top:20px">
      <nodata></nodata>
    </div>
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuerys.page"
        :page-size="listQuerys.limit"
        layout=" total,prev, pager, next,jumper"
        :total="count"
        v-if="count>0"
      ></el-pagination>
    </div>

    <!-- 免训申请 -->
    <el-dialog
    title="免训申请"
    :visible.sync="passDialog"
    width="30%"
    destroy-on-close
    >
      <el-form ref="tempRef" :model="passFrom" :rules="passRules" label-width="80px">
        <el-form-item label="上传附件">
          <div style="display:flex">
            <el-upload
              :headers="headers"
              action="/resource/File/UploadFile"
              :on-remove="fileRemoveFun"
              :on-success="uploadFileSuccess"
              multiple
              :auto-upload="true"
              v-model="passFrom.files"
              accept=".ppt,.pdf,.pptx,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.zip,.rar,.7z,.tar,.gz"
            >
              <el-button type="primary">点击上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="晋升类别" prop="typeId">
          <el-select v-model="passFrom.typeId" clearable placeholder="请选择晋升类别">
            <el-option v-for="(item,index) in promotionList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请免训" prop="cateId">
          <el-select v-model="passFrom.cateId" clearable placeholder="请选择晋升类别">
            <el-option v-for="(item,index) in promotionList2" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请理由" prop="cause">
          <el-input type="textarea" :rows="5" placeholder="请输入理由" v-model="passFrom.cause" clearable></el-input>
        </el-form-item>
        
        <el-form-item label="备注">
          <el-input type="textarea" :rows="3" v-model="passFrom.remark" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.prevent="passDialog = false">取 消</el-button>
        <el-button @click.prevent="passApplicationFun" type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 附件列表 -->
    <el-dialog
    title="文件下载"
    :visible.sync="flieListDlog"
    width="500px"
    destroy-on-close
    >
      <el-table
      :data="selFileList"
      style="width:100%"
      border
      >
        <el-table-column min-width="150px" label="文件名称" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fileName }}</span>
          </template>
        </el-table-column>
        <el-table-column width="100px" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click.prevent="downFile(scope.row.fileUrl,scope.row.fileName)" type="text" size="mini">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 审核记录 -->
    <el-dialog
    title="审核记录"
    :visible.sync="auditingDlog"
    width="850px"
    destroy-on-close
    >
      <el-table
      :data="auditList"
      style="width:100%"
      border
      >
        <el-table-column min-width="130px" prop="actname" label="步骤" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column min-width="100px" prop="rolename" label="角色" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column width="90px" prop="state" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 1" type="success">已处理</el-tag>
            <!-- <el-tag v-else-if="scope.row.state === -1" type="danger">不通过</el-tag> -->
            <el-tag v-else type="info">未处理 </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="130px" prop="createtime" label="操作时间" align="center"></el-table-column>
        <el-table-column min-width="150px" prop="idea" label="处理意见" show-overflow-tooltip align="center"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  getExemptionTrainLoadApi,
  addPass,
  getFlowApi,
} from '@/api/train/index.js';
import {
  getList
} from '@/api/pmi/dictionarys.js';
export default {
  name: 'iamApplication',
  data() {
    return {
      listQuerys: {
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
      },
      count: 0,
      list: [],
      passDialog: false,
      passFrom: {
        typeId: '',
        cateId: '',
        cause: '',
        remark: '',
        files: [],
      },
      passRules: {
        cause: [{ required: true, message: '请输入申请理由', trigger: 'blur' }],
        typeId: [{ required: true, message: '晋升类别不能为空', trigger: ['change','blur'] }],
        cateId: [{ required: true, message: '免训申请不能为空', trigger: ['change','blur'] }],
      },
      fileList: [],
      flieListDlog: false,
      selFileList: [],
      auditingDlog: false,
      auditList: [],
      promotionList: [],
      promotionList2: [],
    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
  },
  created() {
    this.getList();
  },
  methods:{
    handleSizeChange(val) {
      this.listQuerys.limit = val;
    },
    handleCurrentChange(val) {
      this.listQuerys.page = val;
      this.getList();
    },
    getList() {
      getExemptionTrainLoadApi(this.listQuerys).then(res=>{
        if(res.code == 200){
          this.list = res.data;
          this.count = res.count;
        }
      })
    },
    //获取晋升类别
    getPromotionList(){
      let para = {
        page: 1,
        limit: 100,
        namespaceId: 70,
      };
      getList(para).then(res=>{
        if(res.code == 200){
          this.promotionList = res.data;
        }
      })
      let para2 = {
        page: 1,
        limit: 100,
        namespaceId: 55,
      };
      getList(para2).then(res=>{
        if(res.code == 200){
          this.promotionList2 = res.data;
        }
      })
    },
    //打开申请表页面
    openSeeApplication(row){
      window.open('/applicationFrom?id=' + row.id);
    },
    //发起申请
    sendApplication(){
      this.fileList = [];
      this.getPromotionList();
      this.passDialog = true;
    },
    //上传文件成功
    uploadFileSuccess(res,file){
      this.fileList.push(file);
    },
    //移除上传文件触发
    fileRemoveFun(file, fileList){
      this.fileList = fileList;
    },
    //提交申请
    passApplicationFun(){
      let files = [];
      this.fileList.forEach(item=>{
        let obj = {};
        obj.fileName = item.name;
        if(item.response){
          obj.fileUrl = item.response.result;
        } else {
          this.$message.error('请上传附件');
          return;
        }
        files.push(obj);
      })
      if (files.length===0) {
        this.$message.error('请上传附件');
        return;
      }

      let para = {
        userId: this.$store.state.User.ids,
        cause: this.passFrom.cause,
        typeId: this.passFrom.typeId,
        cateId: this.passFrom.cateId,
        remark: this.passFrom.remark,
        files: files.length > 0 ? JSON.stringify(files) : '',
      }
      this.$refs['tempRef'].validate((valid) => {
        if (valid) {
          addPass(para).then((res) => {
            if (res.code == 200) {
              this.$message.success('免训申请提交成功！');
              this.passDialog = false;
              this.getList();
              this.passFrom = {
                typeId: '',
                cateId: '',
                cause: '',
                remark: '',
                files: [],
              };
            }
          });
        }
      });
    },
    //查看下载文件列表
    openfileList(row){
      this.selFileList = row.files ? JSON.parse(row.files) : [];
      this.flieListDlog = true;
    },
    //下载文件
    downFile(url,name){
      let link = document.createElement('a');
      link.href = url;
      link.download = name;
      link.click();
    },
    //打开审核列表
    openAuditList(row){
      getFlowApi({ id: row.id }).then(res=>{
        if(res.code == 200){
          this.auditList = res.result;
          this.auditingDlog = true;
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding: 10px;
  box-sizing: border-box;
}
.searchModel{
  padding: 10px 0px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 40px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
}
.header > div:nth-child(1) {
  width: 100px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
}
.teacherbook {
  position: relative;
  right: 20px;
  margin-right: 10px;
}
.header > div:nth-child(1):hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}
.metter > div {
  /* padding-left: 18px; */
  margin-top: 10px;
  text-align: center;
  margin: 0 auto;
}

.nav {
  /* width: 830px; */
  height: 160px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
  /* padding-left: 16px; */
  padding-top: 12px;
  margin-left: 20px;
}
.nav:hover {
  box-shadow: 2px 2px 5px rgba(52, 194, 250, 0.969) !important;
}
.pagination {
  margin-top: 10px;
  text-align: center;
}
.tablehead {
  display: flex;
  height: 46px;
  color: #fff;
  background: #409eff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.table_container {
  display: flex;
  height: 40px;
  border-bottom: 1px solid #efefef;
}

.el-table__header {
  width: 100%;
}
</style>